import React from 'react'

const StockTransfers = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Stock Transfers</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Transfer Warehouses & Branches</li>
            <li className="breadcrumb-item active">Stock Transfers</li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="bi bi-arrow-left-right me-2"></i>
                  Stock Transfers
                </h5>
                <p>View and manage all stock transfers. Track transfer requests, approvals, and completed transfers between warehouses and branches.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default StockTransfers

